<template>
  <div id="step-6-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step6Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'Which of the following should you do before closing on your loan?',
          type: 'multipleChoice',
          options: [
            'Provide all requested documents to the lender',
            'Obtain homeowners insurance',
            'Lock in your interest rate',
            'Review your closing disclosure and settlement fees',
          ],
          correctAnswer: [0, 1, 2, 3],
          bottomHeaderTrue: 'Correct!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Before you close on your loan, you want to make sure you have all of your documentation sent to the lender, have obtained homeowners insurance, confirmed and locked in your interest rate and reviewed your closing disclosure and outstanding fees.',
        },
        {
          prompt:
            "You don't need to read every piece of paperwork you sign at closing.",
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 1,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "While it may be tempting to just sign without reading, it's extremely important to understand all documents you are signing since they're legally binding.",
        },
        {
          prompt: 'What does a title company do?',
          type: 'multipleChoice',
          options: [
            'Runs a title search to determine legal ownership',
            'Checks to make sure there are no liens on the property',
            'Issues title insurance',
            'Ensures that the deed is recorded properly with the new owner',
          ],
          correctAnswer: [0, 1, 2, 3],
          bottomHeaderTrue: 'That’s right!',
          bottomHeaderFalse: 'Almost.',
          bottomText:
            "The title company will run a title search on the property to determine legal ownership, including any outstanding claims or liens on the property. Then, they'll issue the title insurance for that property. They will also make sure the deed is recorded properly with the new owner.",
        },
      ],
    };
  },
};
</script>

<style>
</style>
